import { useState } from 'react';
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { useNotificationCount } from '@/hooks/useNotifications';
import { NotificationCenter } from './NotificationCenter';

/**
 * Sprint 4.D — Cloche de notifications dans la topbar/sidebar.
 * Le compteur affiche les notifs non lues (limité à "9+" au-delà de 9).
 *
 * Cliquer ouvre le `NotificationCenter` (popover déroulant).
 */
export function NotificationBell() {
  const [open, setOpen] = useState(false);
  const { data: count } = useNotificationCount();
  const unread = count?.unread ?? 0;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="relative text-gray-300 hover:text-white hover:bg-white/10"
          aria-label={`Notifications (${unread} non lues)`}
        >
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span
              className="absolute top-1 right-1 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-copper px-1 text-[10px] font-semibold text-white"
              aria-hidden
            >
              {unread > 9 ? '9+' : unread}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-96 p-0"
        align="end"
        side="right"
      >
        <NotificationCenter open={open} onClose={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  );
}
